var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.series.length)?_c('GlobalGraph',{staticClass:"graph",attrs:{"series":_vm.computedSeries,"xAxisData":_vm.xAxis,"yAxis":_vm.yAxis,"theme":_vm.theme,"isOnClickValueRequired":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }